import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Grid, Box } from '@mui/material';
import React from 'react';
import StackingCard from '../../components/CardStack/Card/StackingCard';
import CardStack from '../../components/CardStack/CardStack';
import { SmsDecoration } from '../../components/SettingsDecoration/SmsDecoration';
import { Header } from '../../components/SmsSetup/Header';
import { SmsSetupStep1 } from '../../components/SmsSetup/SmsSetup.step1';
import { SmsSetupStep2 } from '../../components/SmsSetup/SmsSetup.step2';
import { useSmsSetupContext } from '../../context/SmsSetupContext/SmsSetupContext';
import { useIsDesktop, useIsTablet } from '../../utils/mediaQueries';
import styles from './styles';
export const SmsSetupPage = () => {
    const isDesktop = useIsDesktop();
    const isTablet = useIsTablet();
    const isTabletOrMobile = isTablet || !isDesktop;
    const { smsSetupContextState: { smsSetupCurrentStep }, } = useSmsSetupContext();
    const settingsDecorationProps = smsSetupCurrentStep === 0 ? { asStandAlonePage: true } : {};
    return (_jsx(Box, { sx: { height: '100%' }, children: _jsx(Grid, { container: true, direction: 'column', rowSpacing: 3, sx: styles.main, children: _jsxs(CardStack, { children: [!isDesktop && smsSetupCurrentStep !== 0 && _jsx(Header, {}), _jsx(StackingCard, { color: smsSetupCurrentStep === 0 || isDesktop ? '#FFFFFF' : '#E4EEEF', children: _jsxs(Box, { sx: {
                                display: 'flex',
                                height: '100%',
                            }, children: [smsSetupCurrentStep === 1 && _jsx(SmsSetupStep1, {}), smsSetupCurrentStep === 2 && _jsx(SmsSetupStep2, {}), (!isTabletOrMobile || smsSetupCurrentStep === 0) && (_jsx(SmsDecoration, { ...settingsDecorationProps }))] }) })] }) }) }));
};
